"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateNames = void 0;
// Sorted templates that maps to question tree
// @author Ning Tang
var TemplateNames;
(function (TemplateNames) {
    // declarative agent
    TemplateNames["DeclarativeAgentBasic"] = "copilot-gpt-basic";
    TemplateNames["DeclarativeAgentWithActionFromScratch"] = "api-plugin-from-scratch";
    TemplateNames["DeclarativeAgentWithActionFromScratchBearer"] = "api-plugin-from-scratch-bearer";
    TemplateNames["DeclarativeAgentWithActionFromScratchOAuth"] = "api-plugin-from-scratch-oauth";
    TemplateNames["DeclarativeAgentWithActionFromExistingApiSpec"] = "api-plugin-from-existing-api";
    TemplateNames["DeclarativeAgentWithExistingAction"] = "api-plugin-existing-api";
    TemplateNames["DeclarativeAgentWithTypeSpec"] = "declarative-agent-typespec";
    TemplateNames["DeclarativeAgentWithGraphConnector"] = "declarative-agent-with-graph-connector";
    TemplateNames["DeclarativeAgentWithActionFromMCP"] = "declarative-agent-with-action-from-mcp";
    TemplateNames["DeclarativeAgentMetaOSNewProject"] = "declarative-agent-meta-os-new-project";
    TemplateNames["DeclarativeAgentMetaOSUpgradeProject"] = "declarative-agent-meta-os-upgrade-project";
    // custom engine agent
    TemplateNames["BasicCustomEngineAgent"] = "basic-custom-engine-agent";
    TemplateNames["WeatherAgent"] = "weather-agent";
    // agent for Teams
    TemplateNames["CustomCopilotBasic"] = "custom-copilot-basic";
    TemplateNames["CustomCopilotRagCustomize"] = "custom-copilot-rag-customize";
    TemplateNames["CustomCopilotRagAzureAISearch"] = "custom-copilot-rag-azure-ai-search";
    TemplateNames["CustomCopilotRagCustomApi"] = "custom-copilot-rag-custom-api";
    TemplateNames["CustomCopilotRagMicrosoft365"] = "custom-copilot-rag-microsoft365";
    TemplateNames["CustomCopilotAssistantNew"] = "custom-copilot-assistant-new";
    TemplateNames["CustomCopilotAssistantAssistantsApi"] = "custom-copilot-assistant-assistants-api";
    TemplateNames["TeamsCollaboratorAgent"] = "teams-collaborator-agent";
    // Copilot connector
    TemplateNames["GraphConnector"] = "graph-connector";
    // tab
    TemplateNames["Tab"] = "non-sso-tab";
    TemplateNames["SsoTabNaa"] = "sso-tab-naa";
    TemplateNames["DashboardTab"] = "dashboard-tab";
    TemplateNames["TabSSR"] = "non-sso-tab-ssr";
    TemplateNames["SsoTabSSR"] = "sso-tab-ssr";
    TemplateNames["TabSPFx"] = "spfx-tab";
    // bot
    TemplateNames["DefaultBot"] = "default-bot";
    TemplateNames["NotificationExpress"] = "notification-express";
    TemplateNames["NotificationWebApi"] = "notification-webapi";
    TemplateNames["NotificationHttpTrigger"] = "notification-http-trigger";
    TemplateNames["NotificationTimerTrigger"] = "notification-timer-trigger";
    TemplateNames["NotificationHttpTimerTrigger"] = "notification-http-timer-trigger";
    TemplateNames["CommandAndResponse"] = "command-and-response";
    TemplateNames["Workflow"] = "workflow";
    // messaging extension
    TemplateNames["MessageExtensionWithNewApiFromScratch"] = "copilot-plugin-from-scratch";
    TemplateNames["MessageExtensionWithNewApiFromScratchUsingApiKey"] = "copilot-plugin-from-scratch-api-key";
    TemplateNames["MessageExtensionWithNewApiFromScratchUsingOAuth"] = "api-message-extension-sso";
    TemplateNames["MessageExtensionWithExistingApiSpec"] = "copilot-plugin-existing-api";
    TemplateNames["MessageExtensionM365"] = "m365-message-extension";
    TemplateNames["MessageExtensionAction"] = "message-extension-action";
    TemplateNames["LinkUnfurling"] = "link-unfurling";
    TemplateNames["DefaultMessageExtension"] = "default-message-extension";
    // WXP
    TemplateNames["OutlookTaskpane"] = "office-addin-outlook-taskpane";
    TemplateNames["WXPTaskpane"] = "office-addin-wxpo-taskpane";
    TemplateNames["ExcelCFShortcut"] = "office-addin-excel-cfshortcut";
    TemplateNames["OfficeAddinCommon"] = "office-addin-config";
    // VS only
    TemplateNames["Empty"] = "empty";
    TemplateNames["MessageExtensionSearch"] = "message-extension-search";
})(TemplateNames = exports.TemplateNames || (exports.TemplateNames = {}));
//# sourceMappingURL=templateNames.js.map